import React, {useEffect, useState} from 'react';
import * as Store from "../backend/storage";
import * as apiService from "../backend/apiService";
import * as loginApi from "../backend/loginApi"
import {LoginStrategy, MergeableAccount} from "../backend/loginApi"
import {useNavigate} from 'react-router-dom';
import "../style/App.scss"
import ActivityIndicator from "../components/ActivityIndicator";
import MergeAccountsModal from "../components/MergeAccountsModal";
import EmailUnsubModal from "../components/EmailUnsubModal";
import EmailUnsubModalThanks from "../components/EmailUnsubModalThanks";

const EmailUnsubscribe = () => {
    const navigate = useNavigate();

    const [showUnsubModal, setShowUnsubModal] = useState(true);
    const [showThanksModal, setShowThanksModal] = useState(false);

    const handleUnsubscribe = async () => {
        const queryParams = new URLSearchParams(window.location.search);
        const userId = queryParams.get("userId");
        const code = queryParams.get("token");

        if (userId == null || code == null)
            navigate('/')
        else {
            apiService.emailUnsubscribe(userId, code).then().catch(() => navigate('/'));
        }
    }

    return (
        <div className="App-body">
            {showUnsubModal &&
                (<EmailUnsubModal onSubmit={() => {
                    handleUnsubscribe().then();
                    setShowUnsubModal(false);
                    setShowThanksModal(true);
                }} onClose={() => navigate('/')}/>)
            }
            {showThanksModal &&
                (<EmailUnsubModalThanks onClose={() => navigate('/')}/>)
            }
        </div>
    )
}

export default EmailUnsubscribe
